import { api } from './_httpClient'

const getCourse = async payload =>
  api.get(`/course/user?slug=${payload}`)
const progress = async payload => api.post('/progress', payload)

export { getCourse, progress }
